// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y1MH","tabsBox":"styles_tabsBox__2gqws","createButton":"styles_createButton__3K0CK"};